import axios from 'axios'
import {
    END_POINT_LOGIN
} from '../api/EndPoint'
import {
    GET_SUCCESS, RESPONSE_CODE_UNAUTHORIZED
} from '../api/ResponseType'
import {
    LOGIN_SUCCESS, UNAUTHORIZE
} from '../actions/ActionType'
import {
    JWT
} from '../utils/CommonConstant'


export const submitLogin = (prop) => dispatch => {

    const { email, password, cookies } = prop

    axios(
        {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': true,
            'Access-Control-Allow-Origin': true,
            'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6InRoaXRvb0B5b21hLmNvbSIsImV4cCI6MTU1MTM3NzM1Mi4yNTg0MDkzfQ.qco0N0DKcm4kkpEEAShQ2jnwVLPl-MGvS8_6jqkVJGQ'
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_LOGIN,
            data: {email, password}
        }
    ).then( response => {

        if(response.status === GET_SUCCESS) {

            sessionStorage.setItem(JWT, "Bearer "+response.data.message.jwt)
            cookies.set(JWT, "Bearer "+response.data.message.jwt, {path: "/admin/requisitions"})
            cookies.set(JWT, "Bearer "+response.data.message.jwt, {path: "/admin/requisition/detail"})
            cookies.set(JWT, "Bearer "+response.data.message.jwt, {path: "/admin/cvs"})
            cookies.set(JWT, "Bearer "+response.data.message.jwt, {path: "/admin/cv"})
            
            dispatch({
                type: LOGIN_SUCCESS,
                payload: true
            })

        }else {
            window.alert("Server Error!")
            dispatch({
                type: LOGIN_SUCCESS,
                payload: false
            })
        }

    }).catch( error => {

        dispatch({
            type: LOGIN_SUCCESS,
            payload: false
        })

        if(error.response !== undefined) {

           const {
                status,
               data: {
                   _error
               }
           } = error.response

           if(status === RESPONSE_CODE_UNAUTHORIZED){
                window.alert("Failed\n"+ _error.message)
           }

        }else{
            window.alert("Network Error! "+ error)
        }
        
        
    })
}

export const logout= () => dispatch =>{
    dispatch({
        type: LOGIN_SUCCESS,
        payload: false
    })
}

export const unauthorize = () => dispatch => {
    dispatch({
        type: UNAUTHORIZE,
        payload: false
    })
}
